export const baseUrl = process.env.NODE_ENV === 'development' ? '' : 'https://gatewayuat.verisk.com'



// WEBPACK FOOTER //
// ./src/Constants/environment.js